import React, { Component  } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { HeaderHome } from '../../../components/molecues';

class CloseNotice extends Component {
    constructor(props) {
        super(props);
        this.state = {
            current: 11,
            src: null,
        }
    }

    onClickNativeAppNotice = (e) => {
        e.preventDefault();
        this.props.history.push('/nativeappnotice');
    }
    render() {
        return(
            <React.Fragment>
                <HeaderHome/>
                <Body>
                    <TextArea>
                        <TextBold>＜シャドプラス（Web版）　提供終了のご案内＞</TextBold>
                        <Text>※ホーム画面に追加したアイコンからご利用の場合も、今回終了する対象です。</Text>
                        <Br/>
                        <Text>いつもシャドプラスをご利用いただき、誠にありがとうございます。</Text>
                        <Br/>
                        <Text>現在ご利用中のシャドプラス（Web版）は<TextBold>6月末をもちまして提供を終了いたします。</TextBold></Text>
                        <Text>
                            7月1日以降も引き続きご利用いただくには、App StoreまたはGoogle Playから配信中のシャドプラスアプリへ移行をお願いいたします。詳しくは
                            <a  onClick={this.onClickNativeAppNotice} href="/nativeappnotice">「移行について」</a>
                            のご案内をご確認くださいませ。
                        </Text>
                        <Text>なお、<TextBold>7月1日以降はシャドプラスアプリでのご利用のみ</TextBold>となりますので、あらかじめご了承ください。</Text>
                    </TextArea>
                    <TextArea>
                        <TextBold>＜解約をご希望のお客様へ＞</TextBold>
                        <Text>解約をご希望の場合は、お手数ですが、お早めに
                            <a href="https://forms.zohopublic.com/zohouser14263/form/Untitled6/formperma/GuQE-2iYUmIazz1OII8AVpEUvZmoA7RGE6Xwi6onjUU">[各種申請フォーム]</a>
                            よりお手続きをお願いいたします。
                        </Text>
                    </TextArea>
                    <TextArea>
                        <TextBold>【有料会員の皆さまへのご注意】</TextBold>
                        <Text>Web版サービス終了後も、解約手続きが完了していない場合は、決済が継続されますのでご注意ください。継続をご希望でない場合は、お客様ご自身での移行、または解約手続きを必ずお願いいたします。</Text>
                    </TextArea>
                    <Text>ご不明な点がございましたら、お気軽にお問い合わせください。今後ともシャドプラスをよろしくお願い申し上げます。</Text>
                </Body>
            </React.Fragment>
        );
    }
}

export { CloseNotice };

const Body = styled.div`
    padding: 0px 16px;
    font-size: 13px;
    line-height: 1.9;
`;

const Br = styled.div`
    margin-top: 15px;
`;

const TextArea = styled.div`
    margin-top: 30px;
`;

const Text = styled.div`
    margin: 5px;
`;

const TextBold = styled.span`
    font-weight: bold;
`;